<template>
  <div class="animated fadeIn container-fluid pt-4">
    <b-row style="display: flex;   justify-content: space-around;">
      <b-col cols="12" sm="6" lg="4">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix">
            <i class="fa fa-cubes bg-primary p-3 font-2xl mr-3 float-left"></i>
            <div class="h5 text-primary mb-0 mt-2">
              {{ Number(balances[0].balance).toLocaleString() }}
            </div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">
              {{ balances[0].name.toLocaleString() }}
            </div>
          </b-card-body>
          <div slot="footer">
            <b-link
              class="font-weight-bold font-xs btn-block text-muted"
              @click="router.push({ path: '/units-usage-history' })"
              >Units Usage History
              <i class="fa fa-angle-right float-right font-lg"></i
            ></b-link>
          </div>
        </b-card>
      </b-col>

      <b-col cols="14" sm="6" lg="4">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix">
            <i
              class="nav-icon cui-rss bg-warning p-3 font-2xl mr-3 float-left"
            ></i>
            <div class="h5 text-warning mb-0 mt-2">
              ₦{{ Number(balances[1].balance).toLocaleString() }}
            </div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">
              {{ balances[1].name.toLocaleString() }}
            </div>
          </b-card-body>
          <div slot="footer">
            <b-link
              class="font-weight-bold font-xs btn-block text-muted"
              @click="router.push({ path: '/account/manage-newsletters' })"
              >View History <i class="fa fa-angle-right float-right font-lg"></i
            ></b-link>
          </div>
        </b-card>
      </b-col>
      <b-col cols="12" sm="6" lg="4">
        <b-card :no-body="true" footer-class="px-3 py-2">
          <b-card-body class="p-3 clearfix">
            <i class="icon-chart bg-danger p-3 font-2xl mr-3 float-left"></i>
            <div class="h5 text-danger mb-0 mt-2">
              {{ Number(balances[2].balance).toLocaleString() }}
            </div>
            <div class="text-muted text-uppercase font-weight-bold font-xs">
              {{ balances[2].name.toLocaleString() }}
            </div>
          </b-card-body>
          <div slot="footer">
            <b-link
              class="font-weight-bold font-xs btn-block text-muted"
              @click="router.push({ path: '/account/ziga-units' })"
              >View History <i class="fa fa-angle-right float-right font-lg"></i
            ></b-link>
          </div>
        </b-card>
      </b-col> </b-row
    ><!--/.row-->
    <b-row>
      <b-col cols="8">
        <b-card class="d-none d-md-block d-lg-block d-sm-none">
          <b-row>
            <b-col sm="5">
              <h4 id="traffic" class="card-title mb-0">Units Usage</h4>
              <div class="small text-muted">{{ currentYearAndMonth }}</div>
            </b-col>
            <b-col sm="7" class="d-none d-md-block">
              <b-button type="button" variant="primary" class="float-right"
                ><i class="icon-cloud-download"></i
              ></b-button>
              <b-button-toolbar
                class="float-right"
                aria-label="Toolbar with buttons group"
              >
                <b-form-radio-group
                  class="mr-3"
                  id="radiosBtn"
                  buttons
                  button-variant="outline-secondary"
                  v-model="selected"
                  name="radiosBtn"
                >
                  <b-form-radio class="mx-0" value="Day">Day</b-form-radio>
                  <b-form-radio class="mx-0" value="Month">Month</b-form-radio>
                  <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
                </b-form-radio-group>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <main-chart-example
            chartId="main-chart-01"
            class="chart-wrapper"
            style="height:300px;margin-top:40px;"
            height="300"
          ></main-chart-example>
          <div slot="footer">
            <b-row class="text-center">
              <b-col class="mb-sm-2 mb-0">
                <div class="text-muted">Regular</div>
                <strong>0 Messages (0%)</strong>
                <b-progress
                  height="{}"
                  class="progress-xs mt-2"
                  :precision="1"
                  variant="success"
                  :value="40"
                ></b-progress>
              </b-col>
              <b-col class="mb-sm-2 mb-0 d-md-down-none">
                <div class="text-muted">Newsletter</div>
                <strong>0 Messages (0%)</strong>
                <b-progress
                  height="{}"
                  class="progress-xs mt-2"
                  :precision="1"
                  variant="info"
                  :value="20"
                ></b-progress>
              </b-col>
              <b-col class="mb-sm-2 mb-0">
                <div class="text-muted">Birthday</div>
                <strong>0 Messages (0%)</strong>
                <b-progress
                  height="{}"
                  class="progress-xs mt-2"
                  :precision="1"
                  variant="warning"
                  :value="60"
                ></b-progress>
              </b-col>
              <b-col class="mb-sm-2 mb-0">
                <div class="text-muted">Followup</div>
                <strong>0 Messages (0%)</strong>
                <b-progress
                  height="{}"
                  class="progress-xs mt-2"
                  :precision="1"
                  variant="danger"
                  :value="80"
                ></b-progress>
              </b-col>
              <b-col class="mb-sm-2 mb-0 d-md-down-none">
                <div class="text-muted">Transactional</div>
                <strong>0 Messages (0%)</strong>
                <b-progress
                  height="{}"
                  class="progress-xs mt-2"
                  :precision="1"
                  :value="40"
                ></b-progress>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" sm="12" lg="4">
        <b-row>
          <b-col sm="12">
            <h4 id="traffic1" class="card-title">Stats</h4>
          </b-col>

          <b-col
            cols="6"
            md="6"
            ms="6"
            lg="6"
            v-for="(stat, index) in stats"
            :key="'stat' + index"
          >
            <b-card :no-body="true" :class="'mb-2'">
              <b-card-body class="p-3 clearfix">
                <div class="h5 text-info mb-0">
                  {{ stat.total }}
                </div>
                <div class="text-muted text-uppercase font-weight-bold font-xs">
                  {{ stat.name }}
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <vue-fab
      class="d-sm-block d-md-none d-lg-none "
      :mainBtnColor="mainBtnColor"
      :icon="mainBtnIcon"
    >
      <fab-item
        v-for="(item, idx) in menu"
        :idx="idx"
        :key="idx"
        :title="item.title"
        :color="item.color"
        :icon="item.icon"
        @clickItem="clickItem(item.link)"
      />
    </vue-fab>
  </div>
</template>

<script>
import MainChartExample from './dashboard/MainChartExample';
import { Callout } from '@coreui/vue';
import { monthNames } from '@/constants';
import { mapGetters, mapActions } from 'vuex';
import router from '@/router/index';

export default {
  name: 'dashboard',
  components: {
    Callout,
    MainChartExample,
  },
  data: function() {
    return {
      selected: 'Month',
      timer: null,
      tableItems: [
        {
          avatar: { url: 'img/avatars/1.jpg', status: 'success' },
          user: {
            name: 'Yiorgos Avraamu',
            new: true,
            registered: 'Jan 1, 2015',
          },
          country: { name: 'USA', flag: 'us' },
          usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Mastercard', icon: 'fa fa-cc-mastercard' },
          activity: '10 sec ago',
        },
        {
          avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
          user: {
            name: 'Avram Tarasios',
            new: false,
            registered: 'Jan 1, 2015',
          },
          country: { name: 'Brazil', flag: 'br' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Visa', icon: 'fa fa-cc-visa' },
          activity: '5 minutes ago',
        },
      ],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center',
        },
        user: {
          label: 'User',
        },
        country: {
          label: 'Country',
          class: 'text-center',
        },
        usage: {
          label: 'Usage',
        },
        payment: {
          label: 'Payment method',
          class: 'text-center',
        },
        activity: {
          label: 'Activity',
        },
      },
      stats1: [
        {
          name: 'SMS Collections',
          total: 20,
        },
        {
          name: 'Collections Templates',
          total: 5000,
        },
        {
          name: 'Sent Messages',
          total: 20,
        },
        {
          name: 'Schedules',
          total: 20,
        },
        {
          name: 'Drafts',
          total: 20,
        },
        {
          name: 'Newsletter Lists',
          total: 20,
        },
        {
          name: 'Subscribers',
          total: 20,
        },
        {
          name: 'Followups',
          total: 20,
        },
        {
          name: 'Extensible SMS',
          total: 20,
        },
        {
          name: 'Birthday Groups',
          total: 20,
        },
        {
          name: 'Birthday Contacts',
          total: 20,
        },
        {
          name: 'Birthday Messages',
          total: 20,
        },
      ],
      menu: [
        {
          icon: 'icon-feed icons',
          title: 'Create Newsletter',
          color: '#c2185b',
          link: '/newsletter',
        },
        {
          icon: 'fa fa-commenting-o',
          title: 'Compose SMS',
          color: '#c2185b',
          link: '/message-box/?compose=true',
        },
      ],
      mainBtnColor: '#c2185b',
      mainBtnIcon: 'icon-menu icons',
      router: router,
    };
  },
  computed: {
    ...mapGetters('user', ['user']),
    ...mapGetters('dashboard', ['balances', 'charts', 'stats']),
    currentYearAndMonth() {
      return monthNames[new Date().getMonth()] + ' ' + new Date().getFullYear();
    },
  },
  created() {
    this.fetchBalances();
    this.fetchCharts();
    this.fetchStats();
  },

  mounted() {
    this.timer = setInterval(() => {
      this.fetchBalances();
      this.fetchCharts();
      this.fetchStats();
    }, 20000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    ...mapActions('dashboard', ['fetchBalances', 'fetchCharts', 'fetchStats']),

    variant(value) {
      let $variant;
      if (value <= 25) {
        $variant = 'info';
      } else if (value > 25 && value <= 50) {
        $variant = 'success';
      } else if (value > 50 && value <= 75) {
        $variant = 'warning';
      } else if (value > 75 && value <= 100) {
        $variant = 'danger';
      }
      return $variant;
    },
    flag(value) {
      return 'flag-icon flag-icon-' + value;
    },
    isHybrid: function() {
      return typeof window.nativeBridge == 'object';
    },
    clickItem: function(link) {
      router.push(link);
    },
  },
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
